module.exports = __webpack_public_path__ + "img/room05_notebook.eb4ec539.png";